// extracted by mini-css-extract-plugin
export default {"container":"PassportControlModal_container__URS8C","header":"PassportControlModal_header__+XM6p","body":"PassportControlModal_body__p6i8o"};